// extracted by mini-css-extract-plugin
export default {"headerText":"social-linkpost-upload-layout-LinkPostModalHeader__headerText--1dGK7","icon":"social-linkpost-upload-layout-LinkPostModalHeader__icon--2hCcR"};